import { FeatureText } from '../featureText/FeatureText';
import { FeatureInfoWrapper, FeatureInfoContent, FeatureInfoHeading } from './FeatureInfo.styled';

interface FeatureItem {
	text: string;
	featureText?: string;
	textAlign?: 'left' | 'center' | 'right';
}

interface FeatureInfoProps {
	heading: string;
	features: FeatureItem[];
	textAlign?: 'left' | 'center' | 'right';
}

export const FeatureInfo = ({
	heading,
	features,
	textAlign = 'center'
}: FeatureInfoProps) => {
	return (
		<FeatureInfoWrapper $textAlign={textAlign}>
			<FeatureInfoHeading>{heading}</FeatureInfoHeading>
			<FeatureInfoContent>
				{features.map((feature, index) => (
					<FeatureText
						key={index}
						text={feature.text}
						featureText={feature.featureText}
					/>
				))}
			</FeatureInfoContent>
		</FeatureInfoWrapper>
	);
};

FeatureInfo.displayName = 'FeatureInfo';
